import { render, staticRenderFns } from "./HandleAdmin.vue?vue&type=template&id=fea6cd90&scoped=true"
import script from "./HandleAdmin.vue?vue&type=script&lang=js"
export * from "./HandleAdmin.vue?vue&type=script&lang=js"
import style0 from "./HandleAdmin.vue?vue&type=style&index=0&id=fea6cd90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea6cd90",
  null
  
)

export default component.exports